'use strict';

exports.__esModule = true;
exports.share = exports.init = undefined;

var _service = require('./service');

var _service2 = _interopRequireDefault(_service);

var _tips = require('./tips');

var _tips2 = _interopRequireDefault(_tips);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _util = require('./util/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var data = null;

var init = exports.init = function init() {
    var imgUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'media/datuanyuan.jpg';

    var message = '確認過眼神，妳是我想要的人！穿越只有男性的半世界，預約開啟浪漫戀情！';
    var id = '318433822297312';
    var title = '半世界之旅';
    var img = encodeURIComponent('https://events.gm99.com/bsjyy/' + imgUrl);
    var redictUrl = encodeURIComponent('https://events.gm99.com/bsjyy/index.html?cid=31&scid=' + ((0, _util.getUrlParam)('scid') || 'fbshare'));
    data = {
        method: 'share',
        href: 'https://eventsapi.gm99.com/fbShareCustomize/customizeShare/message/' + message + '/app_id/' + id + '/redict_url/' + redictUrl + '/share_title/' + title + '/pic_url/' + img
    };
};
var share = exports.share = function share() {
    getLoginStatus(doShare, login);
};

var getLoginStatus = function getLoginStatus(succFn, errFn) {
    FB.getLoginStatus(function (response) {
        if (response.status === 'connected') {
            succFn && succFn instanceof Function ? succFn() : '';
        } else {
            errFn && errFn instanceof Function ? errFn(succFn) : '';
        }
    });
};

var doShare = function doShare() {
    excSharePopup();
};

var login = function login(succFn) {
    FB.login(function (response) {
        if (response.status === 'connected') {
            succFn && succFn instanceof Function ? succFn() : '';
        }
    });
};
var excSharePopup = function excSharePopup(id, name) {
    FB.ui(data, function (res) {
        if (res && !res.error_message) {
            _service2["default"].share(function (res) {
                alert(_tips2["default"]['shareC']);
                location.reload();
            }, function (err) {
                alert(_tips2["default"]['shareF']);
            });
        }
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/fb.js
// module id = 55
// module chunks = 7 8